import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import {
    Container,
    Row,
    Col,
    Input,
    Label,
    Button,
    Form,
    InputGroup,
    InputGroupAddon,
} from 'reactstrap'
import { isEmpty } from 'lodash'

import { addToCart } from '../../../redux/payment/actions'
import { addComment, getPlan } from '../../../redux/plan/actions'
import {
    toggleFavourite,
    toggleLike,
    togglePublic,
    updatePlan,
} from '../../../redux/plan/actions'

import Price from '../../../components/Payment/Price/Price'
import CartIcon from '../../../assets/img/icons/SHOPPING.svg'
import SearchIcon from '../../../assets/img/icons/SEARCH.svg'
import Icon from '../../../components/Icons/Icon'
import PlanPreview from '../../../components/Plans/PlanPreview/PlanPreview'
import PlanComments from '../../../components/Plans/PlanComments/PlanComments'
import Loading from '../../../components/Loading/Loading'

import './index.css'
import PlanShareModal from '../../../components/Plans/PlanShareModal/PlanShareModal'

const Index = (props) => {
    const plan = useSelector((state) => state.plan.plan)
    const fabrics = useSelector((state) => state.plan.planFabrics)
    const comments = useSelector((state) => state.plan.planComments)

    const loadingFabrics = useSelector((state) => state.plan.loadingFabrics)
    const loadingPlan = useSelector((state) => state.plan.loadingPlan)

    const dispatch = useDispatch()
    const history = useHistory()
    const { id: planId } = useParams()

    useEffect(() => {
        if (planId) dispatch(getPlan(planId))
    }, [planId])

    const onAddNewComment = (comment) => dispatch(addComment(plan.id, comment))
    const [search, setSearch] = useState('')

    const onAddToCart = (fabric) => {
        dispatch(addToCart(fabric))
        history.push('/cart')
    }

    const onLikedPlan = (planId) => {
        dispatch(toggleLike(planId))
        dispatch(updatePlan({ ...plan, isLiked: !plan.isLiked }))
    }
    const onFavouritedPlan = (planId) => {
        dispatch(toggleFavourite(planId))
        dispatch(updatePlan({ ...plan, isFavourited: !plan.isFavourited }))
    }
    const onTogglePublic = (planId, newValue) => {
        dispatch(togglePublic(planId, newValue))
        dispatch(updatePlan({ ...plan, isPublic: !plan.isPublic }))
    }

    const [isShareVisible, setIsShareVisible] = useState(false)
    const toggleShare = () => setIsShareVisible(!isShareVisible)
    const [currentPlanId, setCurrentPlanId] = useState(null)

    const onShare = (planId) => {
        setCurrentPlanId(planId)
        toggleShare()
    }

    const onSearch = () => {
        alert(search)
    }

    return (
        <Container className="plan">
            <Row>
                <Col className="plan__search-wrapper" xs={12}>
                    <Form
                        onSubmit={(e) => {
                            e.preventDefault()
                            onSearch()
                        }}
                    >
                        <InputGroup className="flex-row-reverse w-50">
                            <InputGroupAddon addonType="prepend">
                                <Button className="plans__search-button">
                                    <Icon src={SearchIcon} />
                                </Button>
                            </InputGroupAddon>
                            <Input
                                placeholder="جستجوی طرح ها..."
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </InputGroup>
                    </Form>
                </Col>
                <Col className="plan__header-wrapper" xs={12}>
                    <Button
                        className="d-flex align-items-center"
                        color="link"
                        onClick={() => history.goBack()}
                    >
                        <span className="back-icon">&lsaquo;</span>بازگشت
                    </Button>
                </Col>
                <Col className="plan__container" xs={12}>
                    <Container>
                        <Row>
                            <Col md={3}></Col>
                            <Col md={6}>
                                <PlanPreview
                                    {...plan}
                                    fullSize
                                    onLiked={onLikedPlan}
                                    onFavourited={onFavouritedPlan}
                                    onTogglePublic={onTogglePublic}
                                    loading={loadingPlan}
                                    onShare={onShare}
                                />
                                <PlanComments
                                    comments={comments}
                                    loading={loadingPlan}
                                    onAddComment={onAddNewComment}
                                />
                            </Col>
                            <Col md={3} className="plan__sidebar">
                                {loadingFabrics ? (
                                    <Loading />
                                ) : isEmpty(fabrics) ? (
                                    <p className="text-center text-white">
                                        پارچه‌ای در طرح پیدا نشد
                                    </p>
                                ) : (
                                    fabrics.filter(x=>x.name).map((fabric) => (
                                        <div key={fabric.id} className="plan__sidebar-item mt-3">                                         
                                            <div className="d-flex justify-content-between">
                                                <p className="text-right text-lg">
                                                    {fabric.name}
                                                </p>
                                                {fabric?.images && <img
                                                    className="plan__sidebar-item__img"
                                                    src={fabric?.images[0].src}
                                                />}
                                                
                                            </div>
                                            <Label>قیمت براساس متراژ</Label>
                                            <Price price={fabric.price?.toLocaleString("fa")} />
                                            <a

                                                target="_blank"
                                                href={fabric.permalink}
                                                className="plan__add-to-cart-btn btn btn-primary"
                                            >
                                                <Icon
                                                    src={CartIcon}
                                                    size="lg"
                                                />
                                                خرید پارچه
                                            </a>
                                        </div>
                                    ))
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <PlanShareModal
                toggle={toggleShare}
                visible={isShareVisible}
                planId={currentPlanId}
            />
        </Container>
    )
}

export default Index
